import React from 'react';
import FieldLabel from 'components/styledInput/FieldLabel';

const SectionWrapper = ({ title, description, rightElement, children }) => {
    return (
        // `wizard-section`: a dashed rule between two sections that follow each other (styles/components/_wizardSection.scss).
        <div className={'wizard-section relative flex flex-col gap-6 bg-white rounded-xl p-6'}>
            <div className={'flex justify-between items-start gap-4'}>
                <div className={'flex flex-col gap-2'}>
                    <h1 className='ft-xl font-medium text-gray-900'>{title}</h1>
                    {description && (
                        <p className="ft-sm font-normal text-gray-500 leading-relaxed">
                            {description}
                        </p>
                    )}
                </div>
                {rightElement && (
                    <div className={'shrink-0'}>
                        {rightElement}
                    </div>
                )}
            </div>
            <div className={'flex flex-col gap-4'}>
                {children}
            </div>
        </div>
    );
};

export const FormField = ({ label, optional, aside, children }) => {
    return (
        <div className={'flex flex-col gap-1.5'}>
            <FieldLabel label={label} isOptional={optional} aside={aside} />
            {children}
        </div>
    );
};

export const inputClassName = "w-full h-10 pl-3 pr-3 text-sm placeholder:text-gray-400 border rounded-[0.4rem]";
export const selectClassName = "w-full h-10 pl-3 pr-8 text-sm placeholder:text-gray-400 border rounded-[0.4rem]";
export const textareaClassName = "w-full p-3 text-sm placeholder:text-gray-400 border rounded-[0.4rem] resize-none";

export default SectionWrapper;

